import { io, Socket } from "socket.io-client";
import { SocketEvents, SocketURL } from "config/socket";

let socketClient: Socket | null = null;

const getSocketAuth = () => ({
  token: localStorage.getItem("token") || "",
});

export const getSocketClient = (): Socket => {
  if (!socketClient) {
    socketClient = io(SocketURL(), {
      autoConnect: false,
      auth: getSocketAuth(),
    });
  }

  if (!socketClient.connected) {
    socketClient.auth = getSocketAuth();
    socketClient.connect();
  }

  return socketClient;
};

export const subscribeToSocketEvent = <T>(
  eventName: string,
  handler: (payload: T) => void
) => {
  const socket = getSocketClient();
  socket.on(eventName, handler);

  return () => {
    socket.off(eventName, handler);
  };
};

export const syncSocketRoom = (room: string) => {
  const socket = getSocketClient();

  const joinRoom = () => {
    socket.emit(SocketEvents.Join, room);
  };

  if (socket.connected) {
    joinRoom();
  } else {
    socket.once("connect", joinRoom);
  }

  return () => {
    socket.off("connect", joinRoom);
    if (socket.connected) {
      socket.emit(SocketEvents.Leave, room);
    }
  };
};

export const disconnectSocketClient = () => {
  if (!socketClient) return;

  socketClient.disconnect();
  socketClient = null;
};

export const refreshSocketAuthentication = () => {
  if (!socketClient) return;
  const auth = getSocketAuth();
  socketClient.auth = auth;
  if (socketClient.connected) socketClient.disconnect();
  if (auth.token) {
    socketClient.connect();
  }
};
